import API from './base';

class LeadsAPI extends API {
  create(payload) {
    return this.post('/api/web/v1/leads', payload);
  }
}

export default new LeadsAPI();
